export function initEditCollectionMenu() {
  const triggerElement = document.querySelector(
    "#collection-edit-menu-trigger"
  );
  const contentElement = document.querySelector(
    "#collection-edit-menu-content"
  );

  if (!triggerElement || !contentElement) return;

  contentElement.classList.add("hidden");
  triggerElement.setAttribute("aria-expanded", "false");

  triggerElement.addEventListener("click", (event) => {
    event.stopPropagation();
    const isHidden = contentElement.classList.toggle("hidden");
    triggerElement.setAttribute("aria-expanded", String(!isHidden));
  });

  contentElement.addEventListener("click", () => {
    contentElement.classList.add("hidden");
    triggerElement.setAttribute("aria-expanded", "false");
  });

  document.addEventListener("click", (event) => {
    if (
      !triggerElement.contains(event.target) &&
      !contentElement.contains(event.target)
    ) {
      contentElement.classList.add("hidden");
      triggerElement.setAttribute("aria-expanded", "false");
    }
  });
}
